<app-evida-error [showRetryButton]="false">
    <h2>{{ 'shared.errormessages.status404.title' | translate }}</h2>
    <span class="body-header">{{ 'shared.errormessages.supportinformations' | translate }}</span>
    <p>{{ 'shared.errormessages.status404.description' | translate }}</p>
    <app-evida-button type="secondary" (clicked)="backToHomepage()">{{
        'shared.buttons.back_to_frontpage' | translate
    }}</app-evida-button>
</app-evida-error>
